
import {
  Document
} from '../types';

function filterDocumentBy(documentList: Document[], filter: any): string|undefined {
  let matchedDoc: string|undefined = undefined;
  documentList.forEach((doc) => {
    let match = true;
    Object.entries(filter).forEach(([key, value]) => {
      if ((doc as any)[key] !== value) match = false;
    });
    if (match) matchedDoc = doc.id;
  })

  return matchedDoc;
}

export default filterDocumentBy;